import { createContext } from 'react';

export const ProductCatalogueContext = createContext({
  catalogue: /** @type {Record<string, CatalogueItem>} */ ({}),
  catalogueLoading: false,
  catalogueError: null,
});
